import { ComponentVersionsInherit, ComponentVersions_3_0, Typography } from 'opensolar-ui'
import { useTranslate } from 'react-admin'

const CustomFieldTitle = ({ record, style }) => {
  const translate = useTranslate()
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Typography variant="body2" style={style}>
        {translate('Custom Fields')}: {record ? `"${record.title}"` : ''}
      </Typography>
    </ComponentVersionsInherit>
  )
}

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Typography variant="body2">
        {translate(
          'Create multiple custom fields for your projects and customer contacts to suit your business workflow. You can also create new COGS fields that appear in cost information templates that can help you customise your cost buildup labelling.'
        )}
        {/* commented out the following help link since there is no available an article on this from support team at the moment */}
        {/* <HelpLink href="https://support.opensolar.com/hc/en-us/articles/4411889716761" /> */}
      </Typography>
    </ComponentVersionsInherit>
  )
}

export default {
  list: { lazy: () => import('./CustomFields'), component: 'CustomFieldList' },
  edit: { lazy: () => import('./CustomFields'), component: 'CustomFieldEdit' },
  create: { lazy: () => import('./CustomFields'), component: 'CustomFieldCreate' },
  options: {
    create: {
      title: 'Create Custom Field',
      subtitle: null,
      breadCrumb: 'Create Custom Field',
    },
    list: {
      title: 'Custom Fields',
      subtitle: <Subtitle />,
      breadCrumb: 'Custom Fields',
    },
    edit: {
      title: <CustomFieldTitle />,
      subtitle: null,
      breadCrumb: 'Edit Custom Field',
    },
  },
}
